import { get, post, put, del } from "../request";

/** 门户端标签（与 homePage content.js 一致） */
const WEB_PREFIX = "/web-api/education-content-web/courseCategoryWeb";

/** 管理端课程分类（增删改仍走 admin） */
const ADMIN_PREFIX = "/contentAdmin/courseCategoryAdmin";

const webCfg = { baseURL: "/" };

/** 查询一级标签（门户） */
export function getOneLevelCategories(params) {
  return get(`${WEB_PREFIX}/queryOneLevel`, params, webCfg);
}

/** 查询二级标签（门户） */
export function getTwoLevelCategories(params) {
  return get(`${WEB_PREFIX}/queryTowLevel`, params, webCfg);
}

/** 新增课程分类 */
export function addCourseCategory(data) {
  return post(ADMIN_PREFIX, data);
}

/** 修改课程分类 */
export function updateCourseCategory(data) {
  return put(ADMIN_PREFIX, data);
}

/** 删除课程分类 */
export function deleteCourseCategory(ids) {
  return del(`${ADMIN_PREFIX}/${ids}`);
}



// WEBPACK FOOTER //
// ./src/api/content/courseCategory.js